import { NgModule } from "@angular/core";
import { ConfigComponent } from "./config.component";
import { PoModule, PoPageDefaultComponent } from "@po-ui/ng-components";
import { CommonModule } from "@angular/common";
import { PoTemplatesModule } from "@po-ui/ng-templates";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
    declarations: [ConfigComponent],
    exports: [
        ConfigComponent,
        PoPageDefaultComponent]
    ,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        PoModule,
        PoTemplatesModule
    ]
})
export class ConfigModule { }